/**
 * Chromium can emit "ResizeObserver loop completed with undelivered notifications" when
 * layout updates run in the same turn as observation (modals, expanding cards). CRA's
 * react-error-overlay reports it as a fatal runtime error.
 *
 * 1) Defer every ResizeObserver callback (double rAF) so layout stabilizes before handlers run.
 * 2) Swallow the same message on window.onerror / error (capture) as a fallback.
 */
(() => {
  if (typeof window === "undefined") return;

  const isBenignResizeObserverMessage = (msg) => String(msg || "").includes("ResizeObserver loop");

  window.addEventListener(
    "error",
    (event) => {
      if (isBenignResizeObserverMessage(event?.message || event?.error?.message)) {
        event.stopImmediatePropagation();
        if (typeof event.preventDefault === "function") event.preventDefault();
      }
    },
    true
  );

  const prevOnError = window.onerror;
  window.onerror = function onerrorFilter(message, source, lineno, colno, error) {
    if (isBenignResizeObserverMessage(message) || isBenignResizeObserverMessage(error?.message)) {
      return true;
    }
    if (typeof prevOnError === "function") {
      return prevOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  const RO = window.ResizeObserver;
  if (typeof RO !== "function" || window.__opsMgmtResizeObserverPatched) return;
  window.__opsMgmtResizeObserverPatched = true;

  window.ResizeObserver = class ResizeObserverDeferred extends RO {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch {
              /* ignore */
            }
          });
        });
      });
    }
  };
})();
